import styled from '@emotion/styled';
import { Button } from 'semantic-ui-react';

const StyledButton = styled(Button)`
  margin: 0;
`;

export default StyledButton;
